<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 80vw">
      <div class="modal-header">
        <h3>{{ editingRecord ? "Edit" : "Add" }} Labor Observation</h3>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveRecord">
          <div class="form-grid">
            <div class="form-group">
              <label>Time Recorded *</label>
              <input
                type="datetime-local"
                v-model="form.recorded_at"
                required
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Onset of Labor</label>
              <input
                type="datetime-local"
                v-model="form.onset_of_labor"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Cervical Dilation (cm) *</label>
              <input
                type="number"
                v-model="form.cervical_dilation"
                min="0"
                max="10"
                step="0.5"
                required
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Descent of Head</label>
              <input
                type="text"
                v-model="form.descent_of_head"
                placeholder="e.g. 3/5 or -2 station"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Moulding</label>
              <select v-model="form.moulding" class="form-control">
                <option value="">Select</option>
                <option value="None">None</option>
                <option value="+">+</option>
                <option value="++">++</option>
                <option value="+++">+++</option>
              </select>
            </div>

            <div class="form-group">
              <label>Liquor</label>
              <select v-model="form.liquor" class="form-control">
                <option value="">Select</option>
                <option value="Intact">Intact</option>
                <option value="Clear">Clear</option>
                <option value="Meconium stained">Meconium stained</option>
                <option value="Blood stained">Blood stained</option>
                <option value="Absent">Absent</option>
              </select>
            </div>

            <div class="form-group">
              <label>Contractions / 10 min</label>
              <input
                type="number"
                v-model="form.contractions_per_10_min"
                min="0"
                max="10"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Contraction Duration (sec)</label>
              <input
                type="number"
                v-model="form.contraction_duration_seconds"
                min="0"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Contraction Strength</label>
              <select v-model="form.contraction_strength" class="form-control">
                <option value="">Select</option>
                <option value="Mild">Mild</option>
                <option value="Moderate">Moderate</option>
                <option value="Strong">Strong</option>
              </select>
            </div>

            <div class="form-group">
              <label>Fetal Heart Rate (bpm)</label>
              <input
                type="number"
                v-model="form.fetal_heart_rate"
                min="60"
                max="200"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Maternal Pulse (bpm)</label>
              <input
                type="number"
                v-model="form.maternal_pulse"
                min="30"
                max="220"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Maternal BP</label>
              <div class="bp-inputs">
                <input
                  type="number"
                  v-model="form.bp_systolic"
                  placeholder="Systolic"
                  class="form-control"
                />
                <span class="bp-separator">/</span>
                <input
                  type="number"
                  v-model="form.bp_diastolic"
                  placeholder="Diastolic"
                  class="form-control"
                />
              </div>
            </div>

            <div class="form-group">
              <label>Temperature (°C)</label>
              <input
                type="number"
                v-model="form.maternal_temp"
                step="0.1"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Urine Protein</label>
              <select v-model="form.urine_protein" class="form-control">
                <option value="">Select</option>
                <option value="Nil">Nil</option>
                <option value="+">+</option>
                <option value="++">++</option>
                <option value="+++">+++</option>
              </select>
            </div>

            <div class="form-group">
              <label>Urine Acetone</label>
              <select v-model="form.urine_acetone" class="form-control">
                <option value="">Select</option>
                <option value="Nil">Nil</option>
                <option value="+">+</option>
                <option value="++">++</option>
                <option value="+++">+++</option>
              </select>
            </div>

            <div class="form-group">
              <label>Urine Volume (ml)</label>
              <input
                type="number"
                v-model="form.urine_volume_ml"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox" v-model="form.oxytocin_given" />
                Oxytocin given
              </label>
            </div>

            <div class="form-group" v-if="form.oxytocin_given">
              <label>Oxytocin (drops/min)</label>
              <input
                type="text"
                v-model="form.oxytocin_drops_per_min"
                class="form-control"
              />
            </div>

            <div class="form-group full-width">
              <label>Medications Given</label>
              <textarea
                v-model="form.medications_given"
                class="form-control"
                rows="2"
              ></textarea>
            </div>

            <div class="form-group full-width">
              <label>IV Fluids</label>
              <textarea
                v-model="form.iv_fluids"
                class="form-control"
                rows="2"
              ></textarea>
            </div>

            <div class="form-group full-width">
              <label>Notes</label>
              <textarea
                v-model="form.notes"
                class="form-control"
                rows="3"
              ></textarea>
            </div>

            <div class="form-group">
              <label>Recorded By</label>
              <input
                type="text"
                v-model="form.recorded_by"
                class="form-control"
              />
            </div>
          </div>

          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              {{
                saving
                  ? "Saving..."
                  : (editingRecord ? "Update" : "Save") + " Observation"
              }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../../../api/apiIndex";

export default {
  name: "LaborEntryModal",
  props: {
    visitId: {
      type: [Number, String],
      default: null,
    },
    editRecord: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      saving: false,
      editingRecord: null,
      form: this.emptyForm(),
    };
  },
  created() {
    if (this.editRecord) {
      this.editingRecord = this.editRecord;
      this.form = {
        ...this.emptyForm(),
        ...this.editRecord,
        recorded_at: this.toLocalDateTime(this.editRecord.recorded_at),
        onset_of_labor: this.toLocalDateTime(this.editRecord.onset_of_labor),
      };
    }
  },
  methods: {
    emptyForm() {
      return {
        recorded_at: this.toLocalDateTime(new Date()),
        onset_of_labor: "",
        cervical_dilation: "",
        descent_of_head: "",
        moulding: "",
        liquor: "",
        contractions_per_10_min: "",
        contraction_duration_seconds: "",
        contraction_strength: "",
        fetal_heart_rate: "",
        maternal_pulse: "",
        bp_systolic: "",
        bp_diastolic: "",
        maternal_temp: "",
        urine_protein: "",
        urine_acetone: "",
        urine_volume_ml: "",
        oxytocin_given: false,
        oxytocin_drops_per_min: "",
        medications_given: "",
        iv_fluids: "",
        notes: "",
        recorded_by: "",
      };
    },

    toLocalDateTime(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
        d.getHours()
      )}:${pad(d.getMinutes())}`;
    },

    closeModal() {
      this.$emit("close");
    },

    async saveRecord() {
      this.saving = true;
      try {
        const payload = {
          ...this.form,
          visit_id: this.visitId,
        };

        let response;
        if (this.editingRecord) {
          response = await generalApiRequest(
            `maternity_labor_records/${this.editingRecord.id}`,
            "PUT",
            payload,
            1
          );
        } else {
          response = await generalApiRequest(
            "maternity_labor_records",
            "POST",
            payload,
            1
          );
        }

        if (response.success) {
          this.$emit("saved", response.data);
          this.closeModal();
        } else {
          alert(response.message || "Failed to save observation");
        }
      } catch (error) {
        console.error("Error saving labor record:", error);
        alert("An error occurred while saving the observation");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.mmodal-content {
  background: white;
  border-radius: 10px;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.modal-header {
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}

.modal-body {
  padding: 30px;
  overflow-y: auto;
  flex-grow: 1;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: #495057;
}

.checkbox-label {
  display: flex !important;
  align-items: center;
  gap: 8px;
  margin-top: 28px;
}

.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
}

.bp-inputs {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bp-inputs .form-control {
  flex: 1;
}

.bp-separator {
  font-weight: bold;
  color: #495057;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.btn {
  padding: 10px 25px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
}

.btn-primary {
  background: #667eea;
  color: white;
}

.btn-primary:hover {
  background: #5a6fd8;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 1200px) {
  .form-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}
</style>
